import React, { useState } from "react";
import { Dialog, DialogHeader, DialogBody, DialogFooter, Button, Input, Typography } from "@material-tailwind/react";
import { userAjaxController } from "../Ajax/UserAjaxController";
import { alertController } from "../Controllers/AlertController";

type ResetPasswordDialogProps = {
  open: boolean;
  onClose: () => void;
};

export const ResetPasswordDialog = ({ open, onClose }: ResetPasswordDialogProps) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleReset = async () => {
    if (!email.trim()) {
      alertController.displayAlert("Missing email", "Please enter your email address.", "warning", 3000);
      return;
    }

    setLoading(true);
    try {
      await userAjaxController.initializeResetPassword(email);

      alertController.displayAlert(
        "Email sent",
        "If this email is registered, a password reset link has been sent.",
        "success",
        4000
      );
      setEmail("");
      onClose();
    } catch (error) {
      alertController.displayAlert(
        "Error",
        "An unexpected error occurred while trying to send the password reset email. Please try again.",
        "error",
        4000
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      handler={() => { }}
      size="sm"
      className="password-reset-dialog p-4"
    >
      <div
        onClick={(e) => e.stopPropagation()}
      >
        <DialogHeader>Reset your password</DialogHeader>
        <DialogBody divider>
          <Typography variant="small" color="gray" className="mb-4">
            Please enter your email address below. If it's registered, we'll send you instructions to reset your password.
          </Typography>
          <Input
            label="Email"
            size="lg"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            type="email"
          />
        </DialogBody>
        <DialogFooter className="flex justify-end gap-2">
          <Button variant="text" color="gray" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant="filled"
            color="white"
            onClick={handleReset} disabled={loading}
            className="bg-purple text-white"
          >
            Send Reset Email
          </Button>
        </DialogFooter>
      </div>
    </Dialog>
  );
};
